import Input from '@mui/material/Input'
import InputAdornment from './InputAdornment'

export {
    Input,
    InputAdornment,
}
export default Input
